<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Modifier la structure</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle"><strong>Libellé : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="libelle" v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
              <span class='field-error'>{{ errors.libelle }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle_technique"><strong>Libellé technique : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="libelle_technique" v-model="libelle_technique" :class="{hasError: errors.libelle_technique !== ''}" disabled></b-form-input>
              <span class='field-error'>{{ errors.libelle_technique }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="logo_path"><strong>Logo : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-file v-if="!logo_path" placeholder="Sélectionner le Logo"
                          class="file-input"
                          drop-placeholder="Déposer le fichier ici..."
                          browse-text="Parcourir"
                          :state="errors.attachment !== '' ? false : null"
                          @change="addFile($event)">
              </b-form-file>
              <span v-if="logo_path">
                <b-spinner v-if="loadingLogo" type="border" small></b-spinner>
                <img v-if="!loadingLogo" :src="logoBase64" class="clickable" @click="showLogo()" style="max-height: 100px;"> <i class="ml-3 clickable fa fa-trash text-danger" @click="deleteLogo()"></i>
              </span>
              <span class='field-error'>{{ errors.attachment }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="adresse1"><strong>Adresse 1 : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="adresse1" v-model="adresse1" :class="{hasError: errors.adresse1 !== ''}"></b-form-input>
              <!-- <span class='field-error'>{{ errors.adresse1 }}</span> -->
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="adresse2"><strong>Adresse 2 : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="adresse2" v-model="adresse2" :class="{hasError: errors.adresse2 !== ''}"></b-form-input>
              <!-- <span class='field-error'>{{ errors.adresse2 }}</span> -->
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="code_postal"><strong>Code postal : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="code_postal" v-model="code_postal" :class="{hasError: errors.code_postal !== ''}"></b-form-input>
              <!-- <span class='field-error'>{{ errors.code_postal }}</span> -->
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="ville"><strong>Ville : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" id="ville" v-model="ville" :class="{hasError: errors.ville !== ''}"></b-form-input>
              <!-- <span class='field-error'>{{ errors.ville }}</span> -->
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="ordre"><strong>Ordre : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="number" id="ordre" v-model="ordre"></b-form-input>
              <!-- <span class='field-error'>{{ errors.ordre }}</span> -->
            </b-col>
          </b-row>

          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"/> Liste des structures
            </b-button>
            <b-button type="button" @click="editStructure" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"/> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal centered size="xl" id="modal-logo" ref="modal-logo" title="Logo">
      <img :src="logoBase64">
    </b-modal>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import {isEmpty, permittedImageExtension} from "@/utils/fileHelper";
  export default {
    name: "Edit",
    data() {
      return {
        libelle: "",
        libelle_technique: "",
        logo_path: '',
        logoBase64: '',
        attachment: '',
        loadingLogo: true,
        adresse1: "",
        adresse2: "",
        code_postal: "",
        ville: "",
        ordre: 0,
        errors: {
          libelle: "",
          libelle_technique: "",
          logo_path: "",
          attachment: '',
          adresse1: "",
          adresse2: "",
          code_postal: "",
          ville: "",
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getStructure();
    },
    methods: {
      getStructure() {
        this.$store.commit('IS_LOADING', true)
        let id = this.$route.params.id;
        let self = this;
        this.$axios
          .get("/administration/structures/show/" + id)
          .then((response) => {
            this.id = response.data.structure.id;
            this.libelle = response.data.structure.libelle;
            this.libelle_technique = response.data.structure.libelle_technique;
            this.logo_path = response.data.structure.logo_path;
            this.adresse1 = response.data.structure.adresse1;
            this.adresse2 = response.data.structure.adresse2;
            this.code_postal = response.data.structure.code_postal;
            this.ville = response.data.structure.ville;
            this.ordre = response.data.structure.ordre;
            this.$store.commit('IS_LOADING', false);
            if (!isEmpty(response.data.structure.logo_path)) {
              this.getLogo();
            } else {
              this.loadingLogo = false;
            }
          })
          .catch((error) => {
            this.$store.commit('IS_LOADING', false)
            if (error.response && error.response.status === 404 && self != undefined) {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: 'Attention !!',
                text: `L'espace avec l'id ${id} n'existe pas`,
                showConfirmButton: false,
                timer: 5000
              });
              this.$router.push({path: '/administration/espaces'})
            }
          });
      },
      addFile(event) {
        this.attachment = event.target.files[0]
      },
      editStructure() {
        if (this.validateData()) {
          let self = this;
          let formData = new FormData();
          formData.append('libelle', this.libelle);
          formData.append('libelle_technique', this.libelle_technique);
          formData.append('logo_path', this.logo_path);
          formData.append('file', this.attachment);
          formData.append('adresse1', this.adresse1);
          formData.append('adresse2', this.adresse2);
          formData.append('code_postal', this.code_postal);
          formData.append('ville', this.ville);
          formData.append('ordre', this.ordre);

          this.$axios
            .post("/administration/structures/update/"+this.id, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "La structure a été bien modifiée",
                showConfirmButton: false,
                timer: 3700
              });
              this.clearFields();
              this.returnBack();
            })
            .catch((error) => {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: error,
                showConfirmButton: false,
                timer: 4000
              });
            });
        }
      },
      getLogo() {
        let self = this;
        this.$axios
          .get("/administration/structures/logo/"+this.$route.params.id)
          .then(response => {
            this.logoBase64 = response.data.logo;
            this.loadingLogo = false;
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false);
            // self.handleError(error);
          });
      },
      showLogo() {
        this.$refs['modal-logo'].show();
      },
      deleteLogo() {
        let self = this;
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: 'Voulez-vous vraiment supprimer ce logo ?',
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: '#ff1744',
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer'
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true);
              this.$axios
                .delete('/administration/structures/delete/logo/' + this.$route.params.id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false);
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: 'Le logo a bien été supprimé',
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.getStructure();
                })
                .catch((error) => {
                  self.$store.commit('IS_LOADING', false);
                  // self.handleError(error);
                });
            }
          });
      },
      returnBack() {
        this.$router.push({path: "/administration/structures"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (this.libelle === "") {
          this.errors.libelle = "Le libellé est obligatoire";
          valid = false;
        }
        if (this.libelle_technique === "") {
          this.errors.libelle_technique = "Le libellé technique est obligatoire";
          valid = false;
        }
        // if (this.adresse1 === "") {
        //   this.errors.adresse1 = "L'adresse 1 est obligatoire";
        //   valid = false;
        // }
        // if (this.adresse2 === "") {
        //   this.errors.adresse2 = "L'adresse 2 est obligatoire";
        //   valid = false;
        // }
        // if (this.code_postal === "") {
        //   this.errors.code_postal = "Le code postal est obligatoire";
        //   valid = false;
        // }
        // if (this.ville === "") {
        //   this.errors.ville = "Le nom de la ville est obligatoire";
        //   valid = false;
        // }
        if (!isEmpty(this.attachment)) {
          if (!_.includes(permittedImageExtension, this.attachment.name.split('.').pop().toLowerCase())) {
            valid = false;
            this.errors.attachment = "Le Format de fichier n'est pas autorisé (formats autorisés : "+permittedImageExtension.join(', ')+")";
          }
        }

        return valid;
      },
      clearErrors() {
        this.errors.libelle = "";
        this.errors.libelle_technique = "";
        this.errors.adresse1 = "";
        this.errors.adresse2 = "";
        this.errors.code_postal = "";
        this.errors.ville = "";
      },
      clearFields() {
        this.libelle = '';
        this.libelle_technique = '';
        this.attachment = '';
        this.adresse1 = '';
        this.adresse2 = '';
        this.code_postal = '';
        this.ville = '';
        this.ordre = 0;
      },
    }
  }
</script>
